import * as React from "react"

import {
  Container,
  Row,
  Col,
  Nav,
  NavLink,
  Breadcrumb,
  BreadcrumbItem
} from "shards-react"

import { Img } from "react-image"

// Images
import ListIcon from "../images/list-icon.png"

class ProgramSummary extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <>
        <></>
      </>
    )
  }
}

export default ProgramSummary
